export default __webpack_public_path__ + "42dd89a5ba12be2a5cb32a5b83ff87bb.png";